import ar from './ar.json';
import en from './en.json';
import enGB from './en-GB.json';
import es from './es.json';
import frCA from './fr-CA.json';

const messages = {
    ar,
    en,
    'en-GB': enGB,
    es,
    'fr-CA': frCA,
};
export default messages;
